<div class="flex flex-col items-center gap-6">
  <div class="text-3xl font-extrabold text-pet-cli-color-2">
    {{menu[optionSelected].title}}
  </div>
  <div class="flex px-6 py-3 gap-7 border-[4px] border-gray-400 rounded-lg">
    <button *ngFor="let item of menu; let i = index" [routerLink]="[item.path]"
    [ngClass]="{
      'text-blue-500': optionSelected === i,
      }"
      class="flex flex-col gap-2 items-center justify-center bg-transparent text-pet-cli-color-2 font-semibold border-transparent hover:text-pet-cli-color-1">
      <mat-icon>{{item.icon}}</mat-icon>
      {{item.title}}
    </button>
  </div>
</div>
